<template lang='pug'>
    van-list.order-list(
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad")
        .item(v-for="item in list" :key="item.id")
            img.photo(v-src="item.productPhotoUrl")
            .detail
                .name {{item.productName}}
                .status {{item.status.isShipped?'已发货':'未发货'}}
            .amount {{item.redeemAmount}}个
</template>

<script>
export default {
    props: {
        orderList: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            loading: false,
            finished: false,
            len: 10
        }
    },
    methods: {
        onLoad() {
            setTimeout(() => {
                this.len += 5
                this.loading = false
                if (this.list.length === this.orderList.length) {
                    this.finished = true
                }
            }, 500)
        },
    },
    computed: {
        list() {
            return this.orderList.slice(0, this.len)
        }
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.order-list {
    padding: 0 @spacing;
    .item {
        display: flex;
        padding: @spacing 0;
        border-bottom: 1px solid @mBorderColor;
        .photo {
            width: 6rem;
            height: 3.6rem;
            object-fit: contain;
        }
        .detail {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 3.6rem;
            margin-left: @spacing;
            font-size: 0.8rem;
            width: 8rem;
            .status {
                font-size: 0.65rem;
                color: @themeColor;
            }
        }
        .amount{
            align-self: center;
        }
    }
}
</style>